import {
  faCalendarDays,
  faFlag,
  faTruck,
  faFileContract,
  faWaveSquare,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../../utils/factory/createField'

export const filterFields = [
  {
    section: 'Filtros para o relatório',
    fields: [
      createField({
        id: 'filter.document_type',
        label: 'Tipo de Documento *',
        placeholder: 'Selecione o tipo de documento',
        type: 'select',
        icon: faWaveSquare,
        fullWidth: true,
        isClearable: true,
      }),
      createField({
        id: 'filter.start_date',
        label: 'Período de',
        placeholder: 'Selecione o período inicial',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'filter.end_date',
        label: 'Período até',
        placeholder: 'Selecione o período final',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'filter.status_id',
        label: 'Status',
        placeholder: 'Selecione o status',
        type: 'select',
        isClearable: true,
        icon: faFlag,
      }),
      createField({
        id: 'filter.customer_id',
        label: 'Cliente',
        placeholder: 'Selecione o cliente',
        type: 'select',
        isClearable: true,
        icon: faTruck,
      }),
      createField({
        id: 'filter.contract_id',
        label: 'Contrato',
        placeholder: 'Selecione o contrato',
        type: 'select',
        fullWidth: true,
        isClearable: true,
        icon: faFileContract,
      }),
    ],
  },
]